module.exports = __webpack_public_path__ + "img/guide2.ce6e240c.gif";